import { render, staticRenderFns } from "./advertisingExample.vue?vue&type=template&id=653c8aa3&scoped=true"
import script from "./advertisingExample.vue?vue&type=script&lang=js"
export * from "./advertisingExample.vue?vue&type=script&lang=js"
import style0 from "./advertisingExample.vue?vue&type=style&index=0&id=653c8aa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653c8aa3",
  null
  
)

export default component.exports